module.exports = __webpack_public_path__ + "img/icon-plate.43fed1ac.svg";